import { FC } from "react";
import { useSelector } from 'react-redux';
import TableTab from "../components/tabs/table-tab";
import { MESSAGES } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import columns from '../models/ColumnDefinitions/MessageColumns';
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/MessageSearch';
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { deleteMessage, getMessages } from "../services/messageService";
import { getSiteNamesWithPagination } from "../services/siteService"
import { ListQuery } from "@/models/ListQuery";
import { MESSAGE_TYPE, MESSAGE_TYPES } from "@/constants/messages-constants";
import MessageSearch from "../models/search/MessageSearch";

interface MessagesTabProps {
    setBusy: (isBusy: boolean) => void,
    getCategoriesTotals: () => void,
    messageType: MESSAGE_TYPE,
}

const MessagesTab: FC<MessagesTabProps> = ({ setBusy, getCategoriesTotals, messageType }) => {
    const { translate } = useLocale();
    const lookup: Lookup[] = [
        {
            name: LookupTypes.site,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: MessageSearch.find(item => item.accessor === LookupTypes.site)?.searchOnName
        }
    ]
    
    const getMessageTitle = (messageType: MESSAGE_TYPE): string => {
        switch (messageType) {
            case MESSAGE_TYPES.GENERAL:
                return TranslationKeys.general;
            case MESSAGE_TYPES.BIOMETRIC:
                return TranslationKeys.biometrics;
            default:
                return TranslationKeys.allMessages;
        }
    }

    const getItemPath = (messageType: MESSAGE_TYPE) => {
        switch (messageType) {
            case MESSAGE_TYPES.ALL:
                return "/access-control/configuration/message/";
            case MESSAGE_TYPES.GENERAL:
                return "/access-control/configuration/general/";
            case MESSAGE_TYPES.BIOMETRIC:
                return "/access-control/configuration/biometric-message/";
            default:
                break;
        }
    }

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteMessage(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        getCategoriesTotals();
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const initialiseUserPreferences = (setDetails: (userLoginId, MESSAGES) => void) => {
        setDetails(userLoginId, MESSAGES);
    }
    // <-- end context

    return <TableContextProvider
        dataMethod={(listParameters?: ListQuery) => getMessages(listParameters, messageType)}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useTable
        usePagination
        useSearch
        useSort
        useFilter
        deleteMethod={onDelete}
        lookup={lookup}
        customDelete={{ fieldName: "isDefault", comparisonValue: false }}>
        <TableTab
            title={translate.byKey(getMessageTitle(messageType))}
            rowPath={getItemPath(messageType)}
            selectRows={false} 
            cyName="messages"/>
    </TableContextProvider>
};

export default MessagesTab;
